/* eslint-disable */
/*
  These two errors exist.  We need to tweak the linter to fix this.  

  105:20  error  Must use destructuring props assignment    react/destructuring-assignment
  105:26  error  'children' is missing in props validation  react/prop-types

*/
import React, { useContext } from 'react';
import gql from 'graphql-tag';
// Fetch Polyfill for apollo-client
// https://github.com/apollographql/apollo-client/issues/2780
import 'isomorphic-unfetch';
import { graphql, useQuery } from 'react-apollo';
import { USER_DETAILS, userMetricsQuery } from './constants/queries';
import { UserDetailsProvider } from './../../context/userDetailsContext';
import { Loading } from '../../../shared/components/Loading';
import { getRedirectURL } from '../../../utils/';
import { StoreUserIdentifier } from '../../analyticsManager';
import { ProductAnalyticsContext } from 'Context/ProductAnalytics';
import { useDispatch } from 'react-redux';
import { sha512DigestHex } from 'Utils/ie11SafeCrypto';
import { AnnouncementCookieTypes } from 'Types/announcements';
import { deleteCookie } from 'Utils/cookies';
const GQL_USER_DETAILS = gql(USER_DETAILS);
const withUserData = graphql(GQL_USER_DETAILS);
const userMetricsGql = gql(userMetricsQuery);

interface Props {
  children: any;
}

// NEED TO EXPLORE graphql client api so as to be able to pass down children for appriopriate rendering callback
// e.g. loading screen for loading state, error screen for error states, form for form loading
// @ts-ignore
const Wrapper = withUserData(
  // @ts-ignore
  ({ data: { loading, error, ...data }, ...props }) => {
    const dispatch = useDispatch();

    if (loading) {
      return <Loading isFullscreen={true} />;
    } else if (error) {
      /**
       * User not logged in.
       */
      deleteCookie(AnnouncementCookieTypes.SESSION);
      window.location.href = getRedirectURL();
      // Return error notification.  Will only be displayed briefly before closing
      return (
        <div
          className={'animHolder'}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%) translateY(-50%)',
            maxWidth: '250px',
          }}
        >
          Not authorized, login required...
        </div>
      );
      // @ts-ignore
    } else if (!data.properties.user || !data.properties.user.instId) {
      return (
        <div
          className={'animHolder'}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%) translateY(-50%)',
            maxWidth: '250px',
          }}
        >
          Invalid institution configuration.
          <br />
          Please contact your account representative.
        </div>
      );
    } else {
      // @ts-ignore
      const user = data.properties.user;
      const {
        helpers: { metrics },
        actions: { identify },
      } = useContext(ProductAnalyticsContext);

      const userDetails = {
        ...user,
        instId: String(user.instId),
      };

      //Fetch the insitution name
      useQuery(userMetricsGql, {
        variables: {
          inst_id: userDetails.instId,
          accountId: user.accountId,
        },
        onCompleted: (dataMetrics: any) => {
          //Store the metrics for use in Combined Analytics events, around the application.
          metrics.update(dataMetrics.audience.listMetrics);
          //Register SuperProperties (Creates a cookie)
          if (user.uiid) {
            sha512DigestHex(user.uiid).then(userkeyHex =>
              dispatch(
                StoreUserIdentifier({
                  id: userkeyHex,
                  account_type: user.accountType,
                  institution_id: userDetails.instId,
                  institution_name: dataMetrics.institution.name,
                  first_name: user.firstname,
                  last_name: user.lastname,
                })
              )
            );
          }
        },
      });

      return (
        // @ts-ignore
        <UserDetailsProvider value={userDetails}>{props.children}</UserDetailsProvider>
      );
    }
  }
);

const ApolloUserAuth: React.FC<Props> = ({ children }: Props) => {
  return <Wrapper>{children}</Wrapper>;
};

ApolloUserAuth.defaultProps = {
  children: {},
};

export default ApolloUserAuth;
